import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import { useDispatch } from 'react-redux'
// import { regularPayment } from '../../../actions/payment'
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router'
import { getItem } from '../../../utils/secureStorage'



const BackToModal = ({ mco, status, ...props }) => {
  const { t } = useTranslation();
  const [lng, setLng] = useState();

  useEffect(() => {
    getItem('language').then((v) => setLng(v?.lang));
  }, []);

  const history = useHistory();
  const dispatch = useDispatch()
  // const handleRegularPayment = (body) => {
  //   dispatch(regularPayment(JSON.stringify(body), props.onHide))
  // }
  const backToApp = () => {
    // ercapp:// deep link: mco/status ride along so the native app can
    // confirm the result (it must re-check status against the backend
    // itself rather than trust this URL — see Click to Pay integration notes).
    const params = new URLSearchParams();
    if (status) params.set('status', status);
    if (mco) params.set('mco', mco);
    const qs = params.toString();
    window.location.replace(`ercapp://${qs ? `?${qs}` : ''}`);
  };
  return (
    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className='donation_pop_up_body'
    >
      <Modal.Body style={{ backgroundColor: '#fdfdfd', borderRadius: '10px' }} >
        <div className='modal_body_for_donation_final' style={lng === 'arab' ? { direction: 'rtl' } : null}>
          <label style={{textAlign:'center'}}>{t("Thank you for your donation")}</label>
          <div className='donation_final_popUp_btns_wraper'>
            <button onClick={backToApp} className='donation_final_popUp_btn_first'>
              {t("Back to app")}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default BackToModal
